export default "__VITE_ASSET__AySLLZ5l__"